import { Component } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MentorReviewConfirmDialogComponent } from '../mentor-review-confirm-dialog/mentor-review-confirm-dialog.component';
import { PermissionForStudents } from '@edtech-ui/access-role-permissions/users-permissions-constants/student-roles-permissions.enum';
import { HasPermissionDirective } from '@edtech-ui/access-role-permissions/users-permissions-directives/has-permissions.directives';

@Component({
	selector: 'app-book-session-payment-dialog',
	standalone: true,
	imports: [MatDialogModule, HasPermissionDirective],
	templateUrl: './book-session-payment-dialog.component.html',
	styleUrl: './book-session-payment-dialog.component.scss'
})
export class BookSessionPaymentDialogComponent {

	PermissionForStudents = PermissionForStudents;
	hasPermission = HasPermissionDirective;

	constructor(
		private dialogRef: MatDialogRef<BookSessionPaymentDialogComponent>,
		private dialog: MatDialog,
	) { }


	OpenReviewBookingForm() {
		this.dialog.open(MentorReviewConfirmDialogComponent, {});
		this.close();
	}

	close() {
		this.dialogRef.close();
	}

}